import { ThunkAction } from "redux-thunk";
import { ApplicationApi, PaymentMethod, Child, SharedExpenses } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";
import { ApplicationResponse } from "../../lib-api/models/ApplicationResponse";
import { Action } from "redux";
import { RootState } from "..";
import { Step } from "./applicationState";
import { HasOldLoan } from "../../lib-api/models/HasOldLoan";
import { Car } from "../../lib-api/models/Car";
import { trackEvent } from "../../util/gtm";

export const setAmount = (amount: number) =>
({
    type: "SET_APPLICATION_AMOUNT",
    amount
} as const);
export const setAmountOther = (amount: number) =>
({
    type: "SET_APPLICATION_AMOUNT_OTHER",
    amount
} as const);
export const setStartAmount = (amount: number) =>
({
    type: "SET_APPLICATION_START_AMOUNT",
    amount
} as const);
export const setAmountStatic = (amount: number) =>
({
    type: "SET_APPLICATION_AMOUNT_STATIC",
    amount
} as const);
export const setStep2Alt = (link: string, text: string) =>
({
    type: "SET_APPLICATION_STEP2_ALT",
    link,
    text
} as const);

export const setRepaymentPeriod = (months: number) =>
({
    type: "SET_APPLICATION_REPAYMENT_PERIOD",
    months
} as const);

export const gotoStep = (step: Step) =>
({
    type: "APPLICATION_GOTO",
    step
} as const);

export const setMarried = (married: string, sharedExpenses: SharedExpenses, maritalExpenses: string) =>
({
    type: "APPLICATION_SET_MARRIED",
    married,
    sharedExpenses,
    maritalExpenses
} as const);
export const setRKI = (rkiRegistered: boolean) =>
({
    type: "APPLICATION_SET_RKI",
    rkiRegistered
} as const);
export const setDwelling = (dwelling: string, rent: string) =>
({
    type: "APPLICATION_SET_DWELLING",
    dwelling,
    rent
} as const);
export const setLoanReason = (reason: string) =>
({
    type: "APPLICATION_SET_LOAN_REASON",
    reason
} as const);
export const setOtherLoanReason = (otherReason: string) =>
({
    type: "APPLICATION_SET_OTHER_LOAN_REASON",
    otherReason
} as const);
export const setChildrenCount = (children: Array<Child>) =>
({
    type: "APPLICATION_SET_CHILDREN_COUNT",
    children
} as const);
export const setChildAge = (age: number) =>
({
    type: "APPLICATION_SET_CHILD_AGE",
    age
} as const);
export const setHasCoApplicant = (hasCoApplicant: boolean) =>
({
    type: "APPLICATION_SET_HAS_COAPPLICANT",
    hasCoApplicant
} as const);

export const setCarCount = (cars: Array<Car>) =>
({
    type: "APPLICATION_SET_CARCOUNT",
    cars
} as const);

export const setContactInformation = (
    name: string,
    mobile: string,
    email: string,
) =>
({
    type: "APPLICATION_SET_CONTACT_INFO",
    name,
    mobile,
    email,
    //address,
    //postalcode,
    //city,
} as const);

export const setAseConsent = (
    aseConsent: boolean
) => ({
    type: "APPLICATION_SET_ASE_CONSENT",
    aseConsent,
} as const)

export const setAlmBrandConsent = (
    almBrandConsent: boolean
) => ({
    type: "APPLICATION_SET_ALMBRAND_CONSENT",
    almBrandConsent,
} as const)

export const setApplicationId = (
    id: string,
) =>
({
    type: "APPLICATION_SET_ID",
    id,
} as const);

export const setConsent = (
    termsOfService: boolean,
    creditCheck: boolean,
    eSkat: boolean,
    insurance: boolean,
    marketing: boolean
) =>
({
    type: "APPLICATION_SET_CONSENT",
    termsOfService,
    creditCheck,
    eSkat,
    insurance,
    marketing
} as const);

export const setCoContactInformation = (
    name: string,
    cpr: string,
    email: string
) =>
({
    type: "APPLICATION_SET_COCONTACT_INFO",
    name,
    cpr,
    email
} as const);

export const setCprAndPaymentMethod = (
    cpr: string,
    paymentMethod: PaymentMethod,
    hasOldLoan: HasOldLoan,
    oldLoanAmount: string,
    accountNr: string,
    regNr: string
) =>
({
    type: "APPLICATION_SET_CPR_PAYMENT",
    cpr,
    paymentMethod,
    hasOldLoan,
    oldLoanAmount,
    accountNr,
    regNr
} as const);

export const setApplicationSending = (sending: boolean, error?: Response) =>
({
    type: "APPLICATION_SET_APPLICATION_SENDING",
    sending,
    error
} as const);

export const setApplicationResponse = (response: ApplicationResponse) =>
({
    type: "APPLICATION_SET_APPLICATION_RESPONSE",
    response
} as const);

const api = new ApplicationApi(apiConfiguration);

export const sendApplication = (): ThunkAction<
    any,
    RootState,
    null,
    Action<string>
> => async (dispatch, getState) => {
    dispatch(setApplicationSending(true));
    try {
        var state = getState();
        //const response = await api.apiApplicationsPut({
        //  applicationRequest: state.applicationState.data
        //});
        const response = await api.apiApplicationsSubmitApplicationPost({
            id: state.applicationState.application.id,
            applicationRequest: state.applicationState.data
        });
        console.log(response);
        dispatch(setApplicationResponse(response));
        dispatch(setApplicationSending(false));
        trackEvent(
            "Ansøg",
            "Lendmore",
            "@subid:" + response.id
        )

    } catch (err) {
        console.error(err);
        return dispatch(setApplicationSending(false, err));
    }
};

export type ApplicationAction =
    | ReturnType<typeof setAseConsent>
    | ReturnType<typeof setAlmBrandConsent>
    | ReturnType<typeof setAmount>
    | ReturnType<typeof setAmountOther>
    | ReturnType<typeof setStartAmount>
    | ReturnType<typeof setAmountStatic>
    | ReturnType<typeof setStep2Alt>
    | ReturnType<typeof setRepaymentPeriod>
    | ReturnType<typeof gotoStep>
    | ReturnType<typeof setMarried>
    | ReturnType<typeof setRKI>
    | ReturnType<typeof setChildrenCount>
    | ReturnType<typeof setLoanReason>
    | ReturnType<typeof setOtherLoanReason>
    | ReturnType<typeof setHasCoApplicant>
    | ReturnType<typeof setCarCount>
    | ReturnType<typeof setContactInformation>
    | ReturnType<typeof setApplicationId>
    | ReturnType<typeof setCprAndPaymentMethod>
    | ReturnType<typeof setCoContactInformation>
    | ReturnType<typeof setApplicationSending>
    | ReturnType<typeof setApplicationResponse>
    | ReturnType<typeof setConsent>
    | ReturnType<typeof setChildAge>
    | ReturnType<typeof setDwelling>;
